//export const BACKEND_URL = "http://localhost:3000";
//export const BACKEND_URL = "https://prod.farocg.com";
export const BACKEND_URL = "https://staging.farocg.com";
